'use client';

import { useState } from 'react';

import {
  BreadcrumbItem,
  HeaderAction,
  HeaderContext,
} from '@/components/global/contexts/header-context';

export const HeaderProvider = ({ children }: { children: React.ReactNode }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);
  const [actions, setActions] = useState<HeaderAction[]>([]);

  const value = {
    breadcrumbs,
    setBreadcrumbs,
    actions,
    setActions,
  };

  return (
    <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
  );
};
